/* Johnson Fitness product page (Horizon): postcode check, sheets, variant sync, scroll reveal.
   Event delegation throughout, so it keeps working when Horizon or the theme editor re-renders blocks. */
(function () {
  if (window.jfLoaded) return;
  window.jfLoaded = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Scroll reveal ---------- */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;

  function watch(root) {
    (root || document).querySelectorAll('.jf-reveal:not(.is-in), .jf-stagger:not(.is-in)').forEach(function (n) {
      if (!io || reduce) { n.classList.add('is-in'); } else { io.observe(n); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { watch(); });
  else watch();
  document.addEventListener('shopify:section:load', function (e) { watch(e.target); });
  document.addEventListener('shopify:block:select', function (e) { watch(); });

  /* ---------- Postcode check ---------- */
  /* Regional postcodes: from the current store's Delivery Calculator list. Anything not listed (and not excluded) is metro. */
  var REGIONAL = {};
    "0800,0810,0812,0820,0822,0828,0829,0830,0832,0835,0836,0837,0838,0839,0840,0841,0845,0846,0847,0850,0852,0853,0854,0860,0870,0880,0885,0886,0909,2157,2311,2312,2324,2325,2328,2329,2330,2331,2333,2336,2337,2338,2339,2340,2341,2342,2343,2344,2345,2346,2347,2350,2351,2352,2353,2354,2355,2356,2357,2358,2359,2360,2361,2365,2369,2370,2371,2372,2379,2380,2381,2382,2386,2387,2388,2390,2395,2396,2397,2398,2399,2400,2401,2402,2403,2404,2405,2406,2408,2409,2410,2411,2415,2420,2421,2422,2423,2424,2425,2426,2427,2428,2429,2430,2431,2439,2440,2441,2443,2444,2445,2446,2447,2448,2449,2450,2452,2453,2454,2455,2456,2460,2462,2463,2464,2465,2466,2469,2470,2471,2472,2473,2474,2475,2476,2477,2478,2480,2482,2534,2535,2536,2537,2538,2539,2540,2541,2545,2546,2548,2549,2550,2551,2575,2576,2577,2578,2579,2580,2581,2582,2583,2584,2585,2586,2587,2588,2590,2594,2621,2622,2623,2624,2625,2626,2627,2628,2629,2630,2631,2632,2633,2640,2641,2642,2643,2644,2645,2646,2647,2648,2649,2650,2651,2652,2653,2655,2656,2658,2659,2660,2661,2663,2665,2666,2668,2669,2671,2672,2675,2678,2680,2681,2700,2701,2702,2703,2705,2706,2707,2710,2711,2712,2713,2714,2715,2716,2717,2720,2721,2722,2725,2726,2727,2729,2730,2731,2732,2733,2734,2735,2736,2737,2738,2739,2756,2775,2787,2790,2791,2792,2793,2794,2795,2797,2798,2799,2800,2803,2804,2805,2806,2807,2808,2809,2810,2820,2821,2823,2824,2825,2827,2828,2829,2830,2831,2832,2833,2834,2835,2836,2839,2840,2842,2843,2844,2845,2846,2847,2848,2849,2850,2852,2864,2865,2866,2867,2868,2869,2870,2871,2873,2874,2875,2876,2877,2878,2879,2880,2898,2899,3230,3231,3232,3233,3235,3236,3237,3238,3239,3240,3241,3242,3243,3249,3250,3251,3254,3260,3264,3265,3266,3267,3268,3269,3270,3271,3272,3273,3274,3275,3276,3277,3278,3279,3280,3281,3282,3283,3284,3285,3286,3287,3289,3292,3293,3294,3300,3301,3302,3303,3304,3305,3309,3310,3311,3312,3314,3315,3317,3318,3319,3321,3322,3323,3324,3325,3328,3329,3330,3332,3333,3334,3341,3342,3345,3351,3352,3360,3361,3363,3364,3370,3371,3373,3374,3375,3377,3378,3379,3380,3381,3384,3385,3387,3388,3390,3391,3392,3393,3395,3396,3400,3401,3407,3409,3412,3413,3414,3415,3418,3419,3420,3423,3424,3433,3434,3435,3442,3444,3446,3447,3448,3450,3451,3458,3460,3461,3462,3463,3464,3465,3467,3468,3469,3472,3475,3477,3478,3480,3482,3483,3485,3487,3488,3489,3490,3491,3494,3496,3498,3500,3501,3505,3506,3507,3509,3512,3516,3517,3518,3520,3521,3522,3523,3525,3527,3529,3530,3531,3533,3537,3540,3542,3544,3546,3549,3551,3557,3558,3559,3561,3562,3563,3564,3565,3566,3567,3568,3570,3571,3572,3573,3575,3576,3579,3580,3581,3583,3584,3585,3586,3588,3589,3590,3591,3594,3595,3596,3597,3599,3607,3608,3610,3612,3614,3616,3617,3618,3620,3621,3622,3623,3624,3629,3630,3631,3633,3634,3635,3636,3637,3638,3639,3640,3641,3644,3646,3647,3649,3658,3659,3660,3662,3663,3664,3665,3666,3669,3670,3672,3673,3675,3677,3678,3682,3683,3685,3687,3688,3690,3691,3694,3695,3697,3698,3699,3700,3701,3704,3705,3707,3708,3709,3711,3712,3713,3714,3715,3717,3718,3719,3720,3722,3723,3725,3726,3727,3728,3730,3732,3733,3735,3737,3738,3739,3740,3741,3744,3746,3747,3749,3756,3758,3762,3764,3778,3779,3799,3813,3814,3815,3816,3818,3820,3821,3822,3823,3824,3825,3831,3832,3833,3835,3840,3842,3844,3847,3850,3851,3852,3854,3856,3857,3858,3859,3860,3862,3864,3865,3869,3870,3871,3873,3874,3875,3878,3880,3882,3885,3886,3887,3888,3889,3890,3891,3892,3893,3895,3896,3898,3900,3902,3903,3904,3909,3921,3922,3923,3925,3945,3946,3950,3951,3953,3954,3956,3957,3958,3959,3960,3962,3964,3965,3966,3967,3971,3979,3984,3987,3988,3990,3991,3992,3995,3996,4025,4183,4184,4287,4306,4307,4309,4310,4311,4312,4313,4341,4342,4343,4344,4345,4347,4352,4353,4354,4355,4356,4357,4358,4359,4360,4361,4362,4363,4364,4365,4370,4371,4372,4373,4374,4375,4376,4377,4378,4380,4381,4382,4383,4384,4385,4387,4388,4390,4401,4402,4403,4404,4405,4406,4407,4408,4410,4411,4412,4413,4415,4416,4417,4418,4419,4420,4421,4422,4423,4424,4425,4426,4427,4428,4454,4455,4461,4462,4465,4467,4468,4470,4471,4472,4474,4475,4477,4478,4479,4480,4481,4482,4486,4487,4488,4489,4490,4491,4492,4493,4494,4496,4497,4498,4515,4521,4552,4568,4569,4570,4571,4574,4580,4581,4600,4601,4605,4606,4608,4610,4611,4612,4613,4614,4615,4620,4621,4625,4626,4627,4630,4650,4655,4659,4660,4662,4670,4671,4673,4674,4676,4677,4678,4680,4694,4695,4697,4699,4700,4701,4702,4703,4704,4705,4706,4707,4709,4710,4711,4712,4713,4714,4715,4716,4717,4718,4719,4720,4721,4722,4723,4724,4725,4726,4727,4728,4730,4731,4732,4733,4735,4736,4737,4738,4739,4740,4741,4742,4743,4744,4745,4746,4750,4751,4753,4754,4756,4757,4798,4799,4800,4801,4802,4803,4804,4805,4806,4807,4808,4809,4810,4811,4812,4813,4814,4815,4816,4817,4818,4819,4820,4821,4822,4823,4824,4825,4828,4829,4830,4849,4850,4852,4854,4855,4856,4857,4858,4859,4860,4861,4865,4868,4869,4870,4871,4872,4873,4874,4875,4876,4877,4878,4879,4880,4881,4882,4883,4884,4885,4886,4887,4888,4890,4891,4895,5201,5202,5203,5204,5210,5211,5212,5213,5214,5220,5221,5222,5223,5234,5235,5236,5237,5238,5253,5254,5255,5256,5259,5260,5261,5262,5263,5264,5265,5266,5267,5268,5269,5270,5271,5272,5273,5275,5276,5277,5278,5279,5280,5290,5291,5301,5302,5303,5304,5306,5307,5308,5309,5310,5311,5320,5321,5322,5330,5331,5332,5333,5340,5341,5342,5343,5344,5345,5346,5352,5353,5354,5355,5356,5357,5360,5373,5374,5381,5401,5410,5411,5412,5413,5414,5415,5416,5417,5418,5419,5420,5421,5422,5431,5432,5433,5434,5440,5451,5452,5453,5454,5455,5460,5461,5462,5464,5470,5471,5472,5473,5480,5481,5482,5483,5485,5490,5491,5493,5495,5501,5502,5510,5520,5521,5522,5523,5540,5550,5552,5554,5555,5556,5558,5560,5570,5571,5572,5573,5575,5576,5577,5580,5581,5582,5583,5600,5601,5602,5603,5604,5605,5606,5607,5608,5609,5630,5631,5632,5633,5640,5641,5642,5650,5651,5652,5653,5654,5655,5660,5661,5670,5671,5680,5690,5700,5710,5720,5722,5723,5724,5725,5730,5731,5732,5733,5734,6035,6037,6041,6042,6043,6044,6083,6084,6124,6125,6126,6161,6207,6213,6214,6215,6218,6220,6221,6223,6224,6225,6226,6227,6228,6229,6230,6232,6233,6236,6237,6239,6240,6243,6244,6251,6252,6253,6254,6255,6256,6258,6260,6262,6271,6275,6280,6281,6282,6284,6285,6286,6288,6290,6302,6304,6306,6308,6309,6311,6312,6313,6315,6316,6317,6318,6320,6321,6322,6323,6324,6326,6327,6328,6330,6333,6335,6336,6337,6338,6341,6343,6346,6348,6350,6351,6352,6353,6355,6356,6357,6358,6359,6361,6363,6365,6367,6368,6369,6370,6372,6373,6375,6383,6384,6385,6386,6390,6391,6392,6393,6394,6395,6396,6397,6398,6401,6403,6405,6407,6409,6410,6411,6412,6413,6414,6415,6418,6419,6420,6421,6422,6423,6424,6425,6426,6427,6428,6429,6430,6431,6432,6434,6436,6437,6438,6440,6442,6443,6445,6446,6447,6448,6450,6452,6460,6461,6462,6463,6465,6466,6467,6468,6470,6472,6473,6475,6476,6477,6479,6480,6484,6485,6487,6488,6489,6490,6501,6502,6503,6504,6505,6506,6507,6509,6510,6511,6512,6513,6514,6515,6516,6517,6518,6519,6521,6522,6525,6528,6530,6532,6535,6536,6537,6556,6558,6560,6562,6564,6566,6567,6568,6569,6571,6572,6574,6575,6603,6605,6606,6608,6609,6612,6613,6614,6616,6620,6623,6625,6627,6628,6630,6631,6632,6635,6638,6639,6640,6642,6646,6701,6705,6707,6710,6712,6713,6714,6716,6718,6720,6721,6722,6725,6726,6728,6740,6743,6751,6753,6754,6758,6760,6762,6765,6770,6798,6799,7000,7001,7004,7005,7007,7008,7009,7010,7011,7012,7015,7016,7017,7018,7019,7020,7021,7022,7023,7024,7025,7026,7027,7030,7050,7052,7053,7054,7055,7109,7112,7113,7116,7117,7119,7120,7139,7140,7150,7155,7162,7163,7170,7171,7172,7173,7174,7175,7176,7177,7178,7179,7180,7182,7183,7184,7185,7186,7187,7190,7209,7210,7211,7212,7213,7214,7215,7216,7248,7249,7250,7252,7253,7254,7255,7256,7257,7258,7259,7260,7261,7262,7263,7264,7265,7267,7268,7270,7275,7276,7277,7290,7291,7292,7300,7301,7302,7303,7304,7305,7306,7307,7310,7315,7316,7320,7321,7322,7325,7330,7331,7466,7467,7468,7469,7470".split(',').forEach(function (c) { REGIONAL[c] = true; });

  /* Shared with the cart drawer: 'regional', 'wantas' (WA/NT/TAS) or 'metro' for a 4-digit postcode */
  window.jfZone = function (pc) {
    var n = parseInt(pc, 10);
    if (isExcludedState(n)) return 'wantas';
    if (REGIONAL[pc]) return 'regional';
    return 'metro';
  };

  function isExcludedState(n) {
    return (n >= 800 && n <= 999) || (n >= 6000 && n <= 6999) || (n >= 7000 && n <= 7999); /* NT, WA, TAS */
  }
  function el(tag, text, attrs) {
    var e = document.createElement(tag);
    if (text) e.textContent = text;
    if (attrs) for (var k in attrs) e.setAttribute(k, attrs[k]);
    return e;
  }
  var ICONS = {
    ok: '<svg class="jf-i" viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>',
    no: '<svg class="jf-i" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>',
    info: '<svg class="jf-i" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 8v4M12 16h.01"/></svg>'
  };
  function show(result, state, parts) {
    result.textContent = '';
    var icon = document.createElement('span');
    icon.innerHTML = state === 'ok' ? ICONS.ok : (state === 'quote' ? ICONS.info : ICONS.no);
    result.appendChild(icon.firstChild);
    var text = document.createElement('span');
    parts.forEach(function (p) { text.appendChild(typeof p === 'string' ? document.createTextNode(p) : p); });
    result.appendChild(text);
    result.setAttribute('data-state', state);
    result.hidden = false;
    /* restart the entry animation on each check */
    result.style.animation = 'none'; void result.offsetWidth; result.style.animation = '';
  }
  function markOptions(card, kerb) {
    card.querySelectorAll('[data-jf-opt]').forEach(function (o) {
      o.classList.remove('is-on', 'is-off');
      if (kerb === null) return;
      var isKerb = o.getAttribute('data-jf-opt') === 'kerbside';
      o.classList.add(isKerb ? (kerb ? 'is-on' : 'is-off') : 'is-on');
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-jf-pc]');
    if (!form) return;
    e.preventDefault();
    var card = form.closest('[data-jf-delivery]');
    var input = form.querySelector('input');
    var result = form.querySelector('[data-jf-pc-result]');
    var pc = (input.value || '').replace(/\s/g, '');
    var d = card.dataset;
    try { localStorage.setItem('jf-postcode', pc); } catch (err) {}

    if (!/^\d{4}$/.test(pc)) { markOptions(card, null); show(result, 'error', ['Enter a 4-digit postcode.']); input.focus(); return; }
    var n = parseInt(pc, 10);

    if (d.excluded === 'true' && isExcludedState(n)) {
      var parts = ["We don't currently deliver this item to WA, NT or Tasmania."];
      if (d.phone) { parts.push(' '); parts.push(el('a', 'Call us on ' + d.phone, { href: 'tel:' + d.phone.replace(/\s/g, '') })); parts.push(' to talk through options.'); }
      markOptions(card, false); show(result, 'no', parts); return;
    }
    if (REGIONAL[pc]) {
      markOptions(card, false);
      show(result, 'quote', ['Regional area: delivery is by quote. ', el('a', 'Request a shipping quote', { href: d.quoteUrl || '/pages/contact-us' }), '.']);
      return;
    }
    markOptions(card, true);
    show(result, 'ok', ['Metro area: kerbside delivery' + (d.price ? ' ' + d.price : '') + (d.eta ? ' (' + d.eta.replace(/\.$/, '') + ')' : '') + '.']);
  });

  /* Prefill a postcode the shopper already checked on another product */
  function prefill() {
    var saved = null;
    try { saved = localStorage.getItem('jf-postcode'); } catch (err) {}
    if (!saved) return;
    document.querySelectorAll('[data-jf-pc] input').forEach(function (i) { if (!i.value) i.value = saved; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prefill); else prefill();

  /* ---------- Sheets: native modal dialog; inline fallback for older iPhones (iOS < 15.4) ---------- */
  var supportsDialog = typeof HTMLDialogElement === 'function' && typeof HTMLDialogElement.prototype.showModal === 'function';

  function openSheet(dlg, opener) {
    if (supportsDialog) {
      dlg.classList.remove('is-closing');
      dlg.showModal();
      document.documentElement.style.overflow = 'hidden';
      return;
    }
    if (dlg.hasAttribute('open')) { closeSheet(dlg); return; }
    if (opener && opener.nextElementSibling !== dlg) opener.parentNode.insertBefore(dlg, opener.nextSibling);
    dlg.classList.add('jf-sheet--inline');
    dlg.setAttribute('open', '');
    opener.setAttribute('aria-expanded', 'true');
    if (dlg.scrollIntoView) dlg.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
  function finishClose(dlg) {
    dlg.classList.remove('is-closing');
    if (typeof dlg.close === 'function' && dlg.open) dlg.close();
    document.documentElement.style.overflow = '';
  }
  function closeSheet(dlg) {
    if (supportsDialog) {
      if (reduce) { finishClose(dlg); return; }
      dlg.classList.add('is-closing');
      setTimeout(function () { finishClose(dlg); }, 200);
      return;
    }
    dlg.removeAttribute('open');
    var opener = document.querySelector('[data-jf-open="' + dlg.id + '"]');
    if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus(); }
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var opener = e.target.closest('[data-jf-open]');
    if (opener) {
      var dlg = document.getElementById(opener.getAttribute('data-jf-open'));
      if (dlg) openSheet(dlg, opener);
      return;
    }
    var closer = e.target.closest('[data-jf-close]');
    if (closer) { var sheet = closer.closest('.jf-sheet'); if (sheet) closeSheet(sheet); return; }
    /* tap on the dimmed backdrop closes the sheet */
    if (supportsDialog && e.target.tagName === 'DIALOG' && e.target.classList.contains('jf-sheet')) {
      var r = e.target.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) closeSheet(e.target);
    }
  });
  /* Esc: animate out instead of snapping shut */
  document.addEventListener('cancel', function (e) {
    if (e.target.classList && e.target.classList.contains('jf-sheet')) { e.preventDefault(); closeSheet(e.target); }
  }, true);
  document.addEventListener('close', function (e) {
    if (e.target.classList && e.target.classList.contains('jf-sheet')) document.documentElement.style.overflow = '';
  }, true);

  /* ---------- Variant change: refresh price + stock blocks from Horizon's re-rendered section ---------- */
  document.addEventListener('shopify:product:select', function (e) {
    if (!e.promise || !e.promise.then) return;
    e.promise.then(function (res) {
      var html = res && res.detail && res.detail.html;
      if (!html || !html.querySelectorAll) return;
      html.querySelectorAll('[data-jf-sync][id]').forEach(function (fresh) {
        var current = document.getElementById(fresh.id);
        if (current) current.replaceWith(document.importNode(fresh, true));
      });
    }).catch(function () {});
  });
})();

/* Benefits feature list: red line fills like a timer, then advances. Pauses on hover/focus and when off screen. */
(function () {
  if (window.jfFeatLoaded) return;
  window.jfFeatLoaded = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function items(box) { return Array.prototype.slice.call(box.querySelectorAll('.jf-feat__item')); }
  function select(box, idx, fromUser) {
    var list = items(box);
    list.forEach(function (it, i) {
      var on = i === idx;
      it.classList.toggle('is-active', on);
      var tab = it.querySelector('[role="tab"]');
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.tabIndex = on ? 0 : -1;
      var panel = it.querySelector('[role="tabpanel"]');
      if (on) panel.removeAttribute('aria-hidden'); else panel.setAttribute('aria-hidden', 'true');
      /* restart the timer on the newly active item */
      var fill = it.querySelector('.jf-feat__fill');
      if (on && fill) { fill.style.animation = 'none'; void fill.offsetHeight; fill.style.animation = ''; }
    });
    box.querySelectorAll('.jf-feat__img').forEach(function (img, i) { img.classList.toggle('is-active', i === idx); });
    if (fromUser) box.dataset.touched = '1';
  }
  function setup(box) {
    if (box.dataset.jfReady) return;
    box.dataset.jfReady = '1';
    var ms = parseInt(box.dataset.interval, 10) || 6000;
    box.style.setProperty('--jf-feat-dur', ms + 'ms');
    if (reduce || items(box).length < 2) { box.classList.add('is-static'); return; }
    box.classList.add('is-paused');
    box.addEventListener('animationend', function (e) {
      if (!e.target.classList.contains('jf-feat__fill')) return;
      var list = items(box);
      var cur = list.findIndex(function (it) { return it.classList.contains('is-active'); });
      select(box, (cur + 1) % list.length, false);
    });
    var hover = false, focus = false, visible = false;
    function sync() { box.classList.toggle('is-paused', hover || focus || !visible); }
    box.addEventListener('mouseenter', function () { hover = true; sync(); });
    box.addEventListener('mouseleave', function () { hover = false; sync(); });
    box.addEventListener('focusin', function (e) { focus = !!(e.target.matches && e.target.matches(':focus-visible')); sync(); });
    box.addEventListener('focusout', function () { focus = false; sync(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; sync(); }, { threshold: 0.35 }).observe(box);
    } else { visible = true; sync(); }
  }
  function setupAll() { document.querySelectorAll('[data-jf-feat]').forEach(setup); }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest && e.target.closest('[data-jf-feat] [role="tab"]');
    if (!tab) return;
    var box = tab.closest('[data-jf-feat]');
    select(box, items(box).indexOf(tab.closest('.jf-feat__item')), true);
  });
  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest && e.target.closest('[data-jf-feat] [role="tab"]');
    if (!tab || ['ArrowUp', 'ArrowDown', 'Home', 'End'].indexOf(e.key) < 0) return;
    var box = tab.closest('[data-jf-feat]');
    var list = items(box), i = list.indexOf(tab.closest('.jf-feat__item'));
    var next = e.key === 'Home' ? 0 : e.key === 'End' ? list.length - 1 : (i + (e.key === 'ArrowDown' ? 1 : -1) + list.length) % list.length;
    e.preventDefault(); select(box, next, true); list[next].querySelector('[role="tab"]').focus();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupAll); else setupAll();
  document.addEventListener('shopify:section:load', setupAll);
})();

/* Callback sheet: reopen after the form posts (success or error) so the shopper sees the result */
(function () {
  function reopen() {
    var flag = document.querySelector('#jf-callback-sheet [data-jf-autoopen]');
    var dlg = flag && flag.closest('dialog');
    if (dlg && typeof dlg.showModal === 'function' && !dlg.open) dlg.showModal();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reopen); else reopen();
})();

/* Cart drawer: delivery estimate from the saved postcode, and one-tap add for "Complete your setup" */
(function () {
  if (window.jfCartLoaded) return;
  window.jfCartLoaded = true;

  function getPc() { try { return localStorage.getItem('jf-postcode') || ''; } catch (e) { return ''; } }
  function setPc(v) { try { localStorage.setItem('jf-postcode', v); } catch (e) {} }

  function money(cents, cur) {
    return '$' + (cents / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + (cur || '');
  }

  /* Estimated total: cart total plus kerbside delivery once a metro postcode is known */
  function setTotal(box, addCents) {
    var d = box.dataset;
    var summary = box.closest('.cart-totals') || document;
    var totalEl = summary.querySelector('[data-cart-subtotal]');
    var note = summary.querySelector('[data-jf-cart-note]');
    var base = Number(d.totalCents) || 0;
    var cur = d.cur || '';
    if (totalEl && base) {
      var txt = money(base + (addCents || 0), cur);
      var bdi = totalEl.querySelector('bdi');
      if (bdi) bdi.textContent = txt; else totalEl.textContent = txt;
      totalEl.setAttribute('value', txt);
    }
    if (note) {
      note.textContent = addCents ? 'Includes delivery and GST.' : 'GST included. Delivery calculated at checkout.';
    }
  }

  /* ---------- Real checkout rates ----------
     Shopify works out the delivery price from your shipping profiles. We ask it for the current cart and postcode,
     the same calculation checkout uses. Results are cached per cart + postcode so the drawer doesn't re-ask on every redraw. */
  function stateOf(n) {
    if ((n >= 200 && n <= 299) || (n >= 2600 && n <= 2618) || (n >= 2900 && n <= 2920)) return 'ACT';
    if (n >= 800 && n <= 999) return 'NT';
    if ((n >= 1000 && n <= 2599) || (n >= 2619 && n <= 2899) || (n >= 2921 && n <= 2999)) return 'NSW';
    if ((n >= 3000 && n <= 3999) || (n >= 8000 && n <= 8999)) return 'VIC';
    if ((n >= 4000 && n <= 4999) || (n >= 9000 && n <= 9999)) return 'QLD';
    if (n >= 5000 && n <= 5999) return 'SA';
    if (n >= 6000 && n <= 6999) return 'WA';
    if (n >= 7000 && n <= 7999) return 'TAS';
    return '';
  }
  var rateCache = {};
  function getRates(pc, sig) {
    var key = pc + '|' + sig;
    if (rateCache[key]) return rateCache[key];
    try { var hit = sessionStorage.getItem('jf-rates:' + key); if (hit) { rateCache[key] = Promise.resolve(JSON.parse(hit)); return rateCache[key]; } } catch (e) {}
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var q = 'shipping_address%5Bzip%5D=' + encodeURIComponent(pc) + '&shipping_address%5Bcountry%5D=AU&shipping_address%5Bprovince%5D=' + encodeURIComponent(stateOf(parseInt(pc, 10)));
    var p = fetch(root + 'cart/prepare_shipping_rates.json?' + q, { method: 'POST', headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) return r.json().catch(function () { return {}; }).then(function (j) { return { none: true, error: j }; });
        var tries = 0;
        function poll() {
          return fetch(root + 'cart/async_shipping_rates.json?' + q, { headers: { Accept: 'application/json' } }).then(function (res) {
            if (res.status === 200) return res.json().then(function (j) {
              if (j && j.shipping_rates) return { rates: j.shipping_rates };
              if (++tries > 15) throw new Error('timeout');
              return new Promise(function (ok) { setTimeout(ok, 500); }).then(poll);
            });
            if (res.status === 202 && ++tries <= 15) return new Promise(function (ok) { setTimeout(ok, 500); }).then(poll);
            if (res.status === 422) return res.json().catch(function () { return {}; }).then(function (j) { return { none: true, error: j }; });
            throw new Error('rates ' + res.status);
          });
        }
        return poll();
      })
      .then(function (out) { try { sessionStorage.setItem('jf-rates:' + key, JSON.stringify(out)); } catch (e) {} return out; });
    p.catch(function () { delete rateCache[key]; });
    rateCache[key] = p;
    return p;
  }
  function toCents(price) { return Math.round(parseFloat(price || '0') * 100); }

  function fill(box) {
    var text = box.querySelector('[data-jf-cart-ship-text]');
    var form = box.querySelector('[data-jf-cart-pc]');
    var change = box.querySelector('[data-jf-cart-ship-change]');
    var label = box.querySelector('[data-jf-cart-ship-label]');
    var value = box.querySelector('[data-jf-cart-ship-value]');
    var pc = getPc();
    var d = box.dataset;
    var pickup = '';
    var quote = '<a href="' + (d.quoteUrl || '/pages/contact-us') + '">Request a delivery quote</a>.';
    text.removeAttribute('data-state');
    text.hidden = false;
    if (!/^\d{4}$/.test(pc)) {
      if (label) label.textContent = 'Delivery';
      if (value) value.textContent = '';
      text.textContent = 'Enter your postcode to see the delivery price';
      form.hidden = false; change.hidden = true;
      setTotal(box, 0);
      return;
    }
    if (label) label.textContent = 'Delivery to ' + pc;
    form.hidden = true; change.hidden = false;
    if (value) value.textContent = '';
    text.textContent = 'Checking delivery to ' + pc + '…';
    setTotal(box, 0);
    var mine = pc + '|' + (d.sig || '');
    box.dataset.jfAsk = mine;

    getRates(pc, d.sig || '').then(function (out) {
      if (box.dataset.jfAsk !== mine || !box.isConnected) return;
      var rates = (out && out.rates) || [];
      if (!rates.length) {
        /* none of your shipping profiles deliver this cart to this postcode */
        if (value) value.textContent = 'By quote';
        text.setAttribute('data-state', 'no');
        text.innerHTML = "We can't book delivery to " + pc + ' online for this order. ' + quote;
        setTotal(box, 0);
        return;
      }
      rates.sort(function (a, b) { return toCents(a.price) - toCents(b.price); });
      var best = rates[0];
      var cents = toCents(best.price);
      if (value) value.textContent = cents === 0 ? 'Free' : money(cents, '');
      var name = (best.name || 'Delivery').replace(/\.$/, '');
      var extra = rates.length > 1 ? ' Other options at checkout.' : '';
      text.textContent = name + '.' + extra;
      setTotal(box, d.addToTotal === 'true' ? cents : 0);
    }).catch(function () {
      if (box.dataset.jfAsk !== mine || !box.isConnected) return;
      fallback(box, pc, text, value, pickup, quote);
    });
  }

  /* If Shopify's rate check can't be reached, fall back to the old estimate from the product's delivery tier */
  function fallback(box, pc, text, value, pickup, quote) {
    var d = box.dataset;
    var zone = window.jfZone ? window.jfZone(pc) : 'metro';
    var cents = Number(d.priceCents) || 0;
    if (zone === 'wantas' && d.excluded === 'true') {
      text.setAttribute('data-state', 'no');
      if (value) value.textContent = '';
      text.textContent = "We don't currently deliver this to WA, NT or Tasmania. Call us to talk through options.";
      setTotal(box, 0);
    } else if (zone !== 'metro' || !cents) {
      if (value) value.textContent = 'At checkout';
      text.textContent = 'Delivery is calculated at checkout.';
      setTotal(box, 0);
    } else {
      if (value) value.textContent = (d.multi === 'true' ? 'From ' : '') + money(cents, '');
      text.textContent = 'Kerbside delivery, estimated.';
      setTotal(box, d.addToTotal === 'true' ? cents : 0);
    }
  }
  function fillAll() { document.querySelectorAll('[data-jf-cart-ship]').forEach(function (b) { b.dataset.jfFilled = '1'; fill(b); }); }
  function fillNew() { document.querySelectorAll('[data-jf-cart-ship]:not([data-jf-filled])').forEach(function (b) { b.dataset.jfFilled = '1'; fill(b); }); }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-jf-cart-pc]');
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('input');
    var pc = (input.value || '').replace(/\s/g, '');
    if (!/^\d{4}$/.test(pc)) { input.focus(); input.setAttribute('aria-invalid', 'true'); return; }
    input.removeAttribute('aria-invalid');
    setPc(pc);
    fillAll();
    /* keep the product page's postcode field in sync too */
    document.querySelectorAll('[data-jf-pc] input').forEach(function (i) { i.value = pc; });
  });
  document.addEventListener('click', function (e) {
    var ch = e.target.closest && e.target.closest('[data-jf-cart-ship-change]');
    if (ch) {
      var box = ch.closest('[data-jf-cart-ship]');
      var form = box.querySelector('[data-jf-cart-pc]');
      form.hidden = false; ch.hidden = true;
      var input = form.querySelector('input'); input.value = getPc(); input.focus();
      return;
    }
    var add = e.target.closest && e.target.closest('[data-jf-quick-add]');
    if (add) { e.preventDefault(); quickAdd(add); }
  });

  /* The drawer re-renders after every cart change: refill the estimate each time */
  var queued = false;
  new MutationObserver(function () {
    if (queued) return; queued = true;
    requestAnimationFrame(function () { queued = false; fillNew(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fillAll); else fillAll();

  /* Add to cart without leaving the drawer, then let Horizon refresh it */
  function quickAdd(btn) {
    var id = btn.getAttribute('data-jf-quick-add');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var ids = Array.prototype.map.call(document.querySelectorAll('cart-items-component[data-section-id]'), function (c) { return c.dataset.sectionId; });
    btn.setAttribute('aria-busy', 'true');
    var body = new FormData();
    body.append('id', id); body.append('quantity', '1');
    if (ids.length) body.append('sections', ids.join(','));
    import('@shopify/events').then(function (mod) {
      var Ev = mod.CartLinesUpdateEvent;
      var deferred = Ev.createPromise();
      btn.dispatchEvent(new Ev({ action: 'add', context: 'product', lines: [{ merchandiseId: id, quantity: 1 }], promise: deferred.promise }));
      return fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: body })
        .then(function (r) { return r.json(); })
        .then(function (added) {
          return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            deferred.resolve({
              cart: Ev.createCartFromAjaxResponse(cart),
              detail: { items: cart.items, source: 'jf-cart-upsell', sourceId: 'jf-cart-upsell', itemCount: 1, sections: added.sections, didError: !!added.status }
            });
          });
        });
    }).catch(function () {
      /* fallback: plain add, then go to the cart page */
      fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: body })
        .then(function () { window.location.href = root + 'cart'; });
    }).finally(function () { btn.removeAttribute('aria-busy'); });
  }
})();